import GlobalStyles from './styles/GlobalStyles';
import createTheme from './styles/theme';
import { commonInitApp } from 'common-embedded';
import { CURRENCIES, CURRENCY_SYMBOL } from 'common-ui/src/utils/constants';

const brandObject = {
  country: 'au',
  brandId: 'lwnz',
  currencyCode: CURRENCIES.NZD,
  currency: CURRENCY_SYMBOL.NZD,
};

const initApp = commonInitApp({ brandObject, createTheme, GlobalStyles });

export default initApp;